<div class="label" [class.label--empty]="valueControl.value === ''" [formGroup]="form">
  <label class="label__select-label flex text-12">
    <!-- text label -->
    <div class="flex justify-between p-2 flex-auto">
      <div class="mr-2">{{ getSelectedOption()?.label?.title || 'Select' }}</div>
      <app-icon icon="caret-down" size="lg"></app-icon>
    </div>

    <!-- select options -->
    <select
      *ngIf="!disabled"
      class="input label__select"
      placeholder="Select Option"
      formControlName="value"
      data-test="quizLabelSelect">
      <option value="" data-test="questionAnswerOption">Select</option>
      <option
        *ngFor="let o of options"
        [value]="o.value"
        class="label__option"
        data-test="questionAnswerOption">
        {{ o.label.title }}
      </option>
    </select>
  </label>
</div>
